  import React, { useState } from "react";
  import {
    BrowserRouter as Router,
    useLocation,
    useNavigate,
    Routes,
    Route,
    Link
  } from "react-router-dom";
  import './App.css';
  import { faUser } from '@fortawesome/free-regular-svg-icons';
  import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
  import 'animate.css';

  import Home from './pages/Home.js';
  import Archive from './pages/Archive.js';
  import About from './pages/About.js';
  import Privacy from './pages/Privacy.js';
  import Cigs from './components/Cigs'


  export default function App() {
    const [navToggle, setNavToggle] = useState(false);
    const [userIcon, setUserIcon] = useState(false);
    const [titleAnim, setTitleAnim] = useState(false);
    const [titleClicks, setTitleClicks] = useState(0);

    const location = useLocation();
    const navigate = useNavigate();

    const handleTitleClick = () => {
      if (location.pathname.length > 1) {
        navigate('/')
      } else {
        setTitleClicks(titleClicks + 1)
      }
      setTitleAnim(true);
    }

    return (
      <div className="app">
        <div className="app-nav-bar" style={{ zIndex: 422 }}>
          <a className={`app-title-text ${titleAnim ? "title-click-anim" : ""}`}
            onClick={handleTitleClick}
            onAnimationEnd={() => setTitleAnim(false)}
            style={{ 
              cursor: 'pointer',
              userSelect: 'none'
            }} >
            Mallbrawlreds
          </a>

          <div onClick={() => setNavToggle(!navToggle)}>
              <img 
                src="/mallbrawl.jpg" alt="User Avatar" 
                className={navToggle ? "user-img rotate-clockwise" : "user-img rotate-reset"}  />
          </div>
        </div>

        {titleClicks > 4 && (
          <Cigs />
        )}

        <div> 
          <div style={{ zIndex: 421 }} className={navToggle ? "app-router" : "app-router app-router-up"} onClick={() => setNavToggle(!navToggle)}>
            <Link to="/" className="app-link">✦ Home</Link>
            <Link to="/archive" className="app-link">✦ Archive</Link>
            <Link to="/about" className="app-link">✦ About</Link>
          </div> 
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/about" element={<About />} />
            <Route path="/privacy" element={<Privacy />} />
          </Routes>
        </div>
      </div>
    );
  }
